<template>
  <div>
    <div class="kit__utils__heading">
      <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0"></h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มข้อมูลคู่ค้า</a>
        </div>
      </div>
      <div class="card-body">
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0"></h5>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
              class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
          </div>
        </div>
        <a-table :columns="columns" :dataSource="data" rowKey='operatorCode' :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }" >
          <h6 slot="Operatorblock" slot-scope="text, record">
            <b-badge :variant="getStatus('blocks',text).color" pill href="#" @click="useAction(record.id,text)">
              {{getStatus('blocks',text).name}}
            </b-badge>
          </h6>
          <span slot="Action" slot-scope="text,record">
            <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item @click="showModal('update',record.id)">แก้ไขข้อมูลคู่ค้า </a-menu-item>
              <a-menu-item @click="showOperatorIP(record.id)">ดู IP คู่ค้า </a-menu-item>
              <a-menu-item @click="addAdminOperator(record.id)">เพิ่มแอดมินคู่ค้า </a-menu-item>
              <a-menu-item @click="mangeSettingOperator(record.id)">จัดการตั้งค่าข้อมูลคู่ค้า </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> จัดการ <a-icon type="down" /> </a-button>
          </a-dropdown>
          </span>
        </a-table>
      </div>
    </div>
    <a-modal :title="this.form.title" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk"
      @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" layout="vertical" :rules="rules">
        <div class="row">
          <div class="col-md-12">
            <a-form-model-item label="ชื่อคู่ค้า" prop="name">
              <a-input v-model="form.name" />
            </a-form-model-item>
          </div>
          <div class="col-md-12">
            <a-form-model-item label="DomainOperator" prop="DomainOperator">
              <a-input v-model="form.DomainOperator" />
            </a-form-model-item>
          </div>
          <div class="col-md-12">
            <a-form-model-item label="DomainCallback" prop="DomainCallback">
              <a-input v-model="form.DomainCallback" />
            </a-form-model-item>
          </div>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getName } from '@/utils/status'
import apiClient from '@/services/api'

import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  data() {
    return {
      data: [],
      columns: [
        {
          title: 'ลำดับ',
          key: 'OperatorId',
          dataIndex: 'id',
        },
        {
          title: 'operatorCode',
          key: 'operatorCode',
          dataIndex: 'operatorCode',
        },
        {
          title: 'ชื่อคู่ค้า',
          key: 'operatorName',
          dataIndex: 'name',
        },
        {
          title: 'secretkey',
          key: 'operatorSecretkey',
          dataIndex: 'secretKey',
        },
        {
          title: 'DomainOperator',
          key: 'DomainOperator',
          dataIndex: 'domainOperator',
        },
        {
          title: 'DomainCallback',
          key: 'DomainCallback',
          dataIndex: 'domainCallback',
          width: 250,
        },
        {
          title: 'สถานะ',
          key: 'Operatorblock',
          dataIndex: 'block',
          scopedSlots: { customRender: 'Operatorblock' },
        },
        {
          title: 'ตัวเลือก',
          key: 'Action',
          dataIndex: 'operatorId',
          scopedSlots: { customRender: 'Action' },
        },
      ],
      visible: false,
      form: {
        name: '',
        DomainOperator: '',
        DomainCallback: '',
      },
      rules: {
        name: [
          { required: true, message: 'กรุณากรอกชื่อ', trigger: 'blur' },
          { min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur' },
        ],
        DomainOperator: [
          { required: true, message: 'กรุณากรอก DomainOperator', trigger: 'blur' },
          { min: 3, max: 255, message: 'Length should be 3 to 255', trigger: 'blur' },
        ],
        DomainCallback: [
          { required: true, message: 'กรุณากรอก DomainCallback', trigger: 'blur' },
          { min: 3, max: 255, message: 'Length should be 3 to 255', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    clearForm() {
      this.form = {
        name: '',
        DomainOperator: '',
        DomainCallback: '',
      }
    },
    showModal(type, id = null) {
      // get OpertorCode
      this.clearForm()
      this.form.type = type
      this.form.title = (type === 'insert') ? 'เพิ่มข้อมูลคู่ค้า' : 'แก้ไขข้อมูลคู่ค้า'
      if (type === 'update') {
        this.getDataOperatorMain(id)
      } else {
        this.visible = !this.visible
      }
      this.form.operatorCode = 'ooooo'
      this.form.createdBy = 1
    },
    getDataOperatorMain(id) {
      apiClient.get(`/operatorMain/${id}`).then(res => {
        if (res.data.code === '000') {
          const dataoperatorMain = res.data.responseData.data[0]
          this.form.operatorMainId = dataoperatorMain.id
          this.form.name = dataoperatorMain.name
          this.form.DomainOperator = dataoperatorMain.domainOperator
          this.form.DomainCallback = dataoperatorMain.domainCallback
          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async getOperator() {
      // console.log("sfsfsf",this)
      await apiClient.get('/operatorMain/getData').then(response => {
        if (response.data.code === '000') {
          this.data = response.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },

    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = (this.form.type === 'update') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                // ส่งข้อมูลอัปเดทสถานะ
                // console.log(this.form);
                if (this.form.type === 'update') {
                  return apiClient.put(`operatorMain/update/${this.form.operatorMainId}`, this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error.message}`,
                    )
                  })
                } else {
                  return apiClient.post('operatorMain/create', this.form).then(response => {
                    if (response.status !== 200) {
                      throw new Error(response.message)
                    }
                    return response.data
                  }).catch(error => {
                    Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error.message}`,
                    )
                  })
                }
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              this.visible = false
              this.confirmLoading = false
              this.getOperator()
            }
          })
        }
      })
    },
    handleOk(e) {
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    useAction(OperatorId, status) {
      if (status === 1) this.updateOperatorStatus(OperatorId, 'openStatus')
      if (status === 0) this.updateOperatorStatus(OperatorId, 'blockStatus')
    },
    async updateOperatorStatus(OperatorId, type) {
      const OperatorStatus = (type === 'openStatus') ? 0 : (type === 'blockStatus') ? 1 : null
      const title = (type === 'openStatus') ? 'คุณแน่ใจหรือไม่ที่ต้องการเปิดใช้งาน' : (type === 'blockStatus') ? 'คุณแน่ใจหรือไม่ที่ต้องการปิดการใช้งาน' : null

      if (OperatorStatus !== '') {
        await Swal.fire({
          title: title,
          icon: 'question',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: (value) => {
            if (value) {
              const data = { OperatorStatus }
              return apiClient.put(`/operatorMain/updateStatus/${OperatorId}`, data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error.message}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.getOperator()
          }
        })
      }
    },
    showOperatorIP(OperatorId) {
      this.$router.push({
        path: `/operator/operatorIP/${OperatorId}`,
      })
    },
    mangeSettingOperator(id) {
      apiClient.get(`/setting/${id}`).then(res => {
        if (res.data.code === '000') {
          this.$router.push({
            path: `/operator/setting/${id}`,
          })
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    addAdminOperator(id) {
      if (id !== null) this.createOperatorAdmin(id)
    },
    async createOperatorAdmin(id) {
      const title = 'คุณแน่ใจหรือไม่ที่ต้องการแอดมิน Operator'

      if (id !== '') {
        await Swal.fire({
          title: title,
          icon: 'question',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: (value) => {
            if (value) {
              apiClient.post(`/operator/create/${id}`).then(res => {
                if (res.status !== 200) {
                  throw new Error(res.message)
                }
                return res.data
              }).catch(error => {
                Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value === true) ? 'success' : 'error'
            Toast.fire({
              icon: iconError,
              title: result.value.message,
            })
            // this.getOperator()
            this.$router.push({
              path: `/operator/operatorAdmin/${id}`,
            })
          }
        })
      }
    },
    refreshData() {
      this.loading(true)
      this.getOperator()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  async created() {
    await this.getOperator()
  },

}
</script>

<style>
.dropdown{
  z-index: 9999;
}
</style>
